import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { ClassroomInfo } from "../classroom/classroomSlice";
import { getBackendUrl, LoadState, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { routineDelete } from "../routine/routineInsUpdSlice";

export interface SchoolRoutineState {
    state: LoadStateInfo;
    schoolId?: string;
    list?: ClassroomInfo[];
}

const initialState: SchoolRoutineState = {
    state: notStarted(),
};


export interface RetrieveSchoolRoutineRequest {
    schoolId: string;
}
export const retrieveSchoolRoutine = createAsyncThunk(
    "retrieveSchoolRoutine",
    async (param: RetrieveSchoolRoutineRequest, thunkAPI) => {
        console.debug(`retrieve routine for school ${param.schoolId}`);

        const response = await fetch(`${getBackendUrl()}/api/school/${param.schoolId}/routine`, {
            signal: thunkAPI.signal,
            headers: {
                "Authorization": `Bearer ${getToken()}`,
            }
        });

        if (response.ok) {
            return await response.json();
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    },
    {
        condition: (param: RetrieveSchoolRoutineRequest, thunkAPI) => {
            const state = thunkAPI.getState() as RootState;
            const status = state.routine.state;
            if (status && (status.state == LoadState.Loading || status.state == LoadState.Failed)) {
                return false; // Do not proceed if already loading
            }
            return true; // Proceed with the request
        }
    }
);


export const schoolRoutinesSlice = createSlice({
    name: "schoolRoutine",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        check: (state, action: PayloadAction<string>) => {
            if (state.schoolId != action.payload) {
                state.state = notStarted();
                state.schoolId = action.payload;
                state.list = undefined;
            }
        },
        clean: (state) => {
            state.state = notStarted();
            state.list = undefined;
        }
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
        builder
            .addCase(retrieveSchoolRoutine.pending, (state, action) => {
                state.state = loading();
                state.list = undefined;
                state.schoolId = action.meta.arg.schoolId;
            })
            .addCase(retrieveSchoolRoutine.fulfilled, (state, action) => {
                console.debug(`${action.type}`);
                state.state = loaded();
                state.list = action.payload;
                state.list?.sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));
            })
            .addCase(retrieveSchoolRoutine.rejected, (state, action) => {
                state.state = error(action);
            })
            .addCase(routineDelete.fulfilled, (state, /* action */) => {
                state.state = notStarted();
            })
            ;
    },
});

// export const { } = schoolRoutinesSlice.actions;

export const selectSchoolRoutines = (state: RootState) => state.schoolRoutines;

export default schoolRoutinesSlice.reducer;
